import Register from './Register'
import SignIn from './SignIn'
import Done from './Done'
import VerifyAccount from './VerifyAccount'
import ForgotPassword from './ForgotPassword'
import CheckEmail from './CheckEmail'
import ResetPassword from './ResetPassword'
import GoogleLoginFrame from './GoogleLogin'

export { SignIn, Register, Done, VerifyAccount, ForgotPassword, CheckEmail, ResetPassword, GoogleLoginFrame }



// WEBPACK FOOTER //
// ./src/features/authentication/components/index.js